import { useState } from "react";
import {
  ActionType,
  CustomTemplate,
  CustomTemplateStatus,
  TemplateContainerMeta,
  TemplateType,
  VariableType,
} from "./models";
import { DbBusinessWhatsappCustomHeader } from "../custom-header/models";

export type ExtendedTemplate = CustomTemplate & {
  parsedContainerMeta: TemplateContainerMeta;
};

export const initialCustomTemplateDetails: CustomTemplate = {
  id: "",
  appId: "",
  elementName: "",
  languageCode: "en",
  templateType: TemplateType.Text,
  category: "MARKETING",
  content: "",
  footer: "",
  example: "",
  header: "",
  exampleHeader: "",
  enableSample: true,
  exampleMedia: "",
  containerMeta: "",
  vertical: TemplateType.Text,
  meta: "",
  data: "",
  status: CustomTemplateStatus.Pending,
  selectedMedia: undefined,
  buttons: [],
  createdOn: "",
  modifiedOn: "",
};
export interface ValidationError {
  for: string; // Field name (e.g., "content", "header")
  message: string; // Error message
  position?: number; // Position in the text
  variable?: string; // The invalid variable text
}

export function useWhatsappTemplateState() {
  const [error, setError] = useState<string | null>(null);
  const [errors, setErrors] = useState<{ for: string; message: string }[]>([]);
  const [step1Errors, setStep1Errors] = useState<
    { for: string; message: string }[]
  >([]);
  const [step2Errors, setStep2Errors] = useState<ValidationError[]>([]);
  const [step3Errors, setStep3Errors] = useState<
    { for: string; message: string }[]
  >([]);
  const [addCustomTemplateCurrentStep, setAddCustomTemplateCurrentStep] =
    useState(1);
  const [editCustomTemplateCurrentStep, setEditCustomTemplateCurrentStep] =
    useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [basicCustomTemplateDetails, setBasicCustomTemplateDetails] =
    useState<CustomTemplate>(initialCustomTemplateDetails);
  const [actionType, setActionType] = useState<ActionType>(ActionType.Add);
  const [customHeader, setCustomHeader] =
    useState<DbBusinessWhatsappCustomHeader | null>(null);
  const [currentVariableType, setCurrentVariableType] = useState<VariableType>(
    VariableType.NAME,
  );
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [templates, setTemplates] = useState<ExtendedTemplate[]>([]);
  const [imageUrlMap, setImageUrlMap] = useState<Record<string, string>>({});

  const resetState = () => {
    setIsLoading(false);
    setError(null);
    setErrors([]);
    setStep1Errors([]);
    setStep2Errors([]);
    setStep3Errors([]);
    setAddCustomTemplateCurrentStep(1);
    setEditCustomTemplateCurrentStep(1);
    setBasicCustomTemplateDetails(initialCustomTemplateDetails);
  };

  return {
    error,
    setError,
    errors,
    setErrors,
    step1Errors,
    setStep1Errors,
    step2Errors,
    setStep2Errors,
    step3Errors,
    setStep3Errors,
    addCustomTemplateCurrentStep,
    setAddCustomTemplateCurrentStep,
    editCustomTemplateCurrentStep,
    setEditCustomTemplateCurrentStep,
    isLoading,
    setIsLoading,
    basicCustomTemplateDetails,
    setBasicCustomTemplateDetails,
    actionType,
    setActionType,
    resetState,
    customHeader,
    setCustomHeader,
    currentVariableType,
    setCurrentVariableType,
    templates,
    setTemplates,
    imageUrlMap,
    setImageUrlMap,
    successMessage,
    setSuccessMessage,
  };
}
